import React from "react";

function TopBar({ title, sectionIcon, onMenuClick, isOnline, actionButton }) {
  return (
    <div className="app-bar bg-blu-uss flex items-center">
      <button className="mr-3" onClick={onMenuClick} aria-label="Apri menu">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.8}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>
      <h1 className="text-lg sm:text-xl font-bold flex-1 flex items-center gap-2">
        <span>{title}</span>
        {sectionIcon && <span className="flex-shrink-0 opacity-90">{sectionIcon}</span>}
      </h1>
      {!isOnline && (
        <span className="flex items-center gap-1 px-3 py-1 rounded-full bg-red-100 text-red-700 font-semibold text-sm">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
            <path d="M2 2l20 20M12 4v2m0 12v2m8-8h-2m-12 0H4m16.24 3.76A9 9 0 003.76 7.76" stroke="#f87171" strokeWidth="2" strokeLinecap="round" />
          </svg>
          Offline
        </span>
      )}
      {actionButton ? (
        <button
          onClick={actionButton.onClick}
          aria-label={actionButton.label || "Azione"}
          className="ml-2 w-10 h-10 flex items-center justify-center rounded-full text-white hover:bg-white/20 transition flex-shrink-0"
        >
          {actionButton.icon}
        </button>
      ) : (
        <span className="ml-2 w-10 h-10 flex-shrink-0" aria-hidden="true" />
      )}
    </div>
  );
}

export default TopBar;
